module.exports = __webpack_public_path__ + "media/images/single18-5ccdecf7a4d755e04d332c1ee1a59413.jpg";